import React from 'react';
import { AppStore } from '../../AppStore';

const WeeklyWisdom = () => {
  const weeklyWisdom = AppStore.useState(s => s.featureData?.weeklyWisdom);

  return (
    <div className="previewTile">
      <div className="featureTitle">Weekly Wisdom</div>
      <div className="weeklyWisdom">{weeklyWisdom}</div>
    </div>
  );
};

export default WeeklyWisdom;